// QR Code Display Component
import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

/**
 * QR Code component for session joining
 */
const QRCodeDisplay = ({ 
  sessionCode, 
  baseUrl = window.location.origin,
  size = 200,
  showCode = true 
}) => {
  // Construct the join URL
  const joinUrl = `${baseUrl}/join/${sessionCode}`;

  return (
    <div className="flex flex-col items-center">
      {/* QR Code */}
      <div className="bg-white p-6 rounded-lg shadow-md border border-pp-rule">
        <QRCodeSVG
          value={joinUrl}
          size={size}
          level="H" // High error correction
          includeMargin={true}
          bgColor="#ffffff"
          fgColor="#1A1D1C"
          imageSettings={{
            src: '/favicon.svg',
            x: undefined,
            y: undefined,
            height: 40,
            width: 40,
            excavate: true,
          }}
        />
      </div>

      {/* Session Code Display */}
      {showCode && (
        <div className="mt-6 bg-pp-deep rounded-xl py-4 px-8">
          <p className="text-white/70 text-sm mb-1 text-center">Session Code</p>
          <p className="text-4xl font-bold font-mono tracking-widest text-white text-center">
            {sessionCode}
          </p>
        </div>
      )}

      {/* Instructions */}
      <p className="text-pp-text-light text-sm mt-4 text-center">
        Scan the QR code or visit{' '}
        <span className="text-pp-teal font-medium">
          {baseUrl.replace(/^https?:\/\//, '')}
        </span>
      </p>
    </div>
  );
};

/**
 * Compact QR code for embedding in smaller spaces
 */
export const QRCodeCompact = ({ sessionCode, size = 100 }) => {
  const joinUrl = `${window.location.origin}/join/${sessionCode}`;
  
  return (
    <div className="bg-white p-2 rounded-lg inline-block">
      <QRCodeSVG
        value={joinUrl}
        size={size}
        level="M"
        bgColor="#ffffff"
        fgColor="#1A1D1C"
      />
    </div>
  );
};

export default QRCodeDisplay;
